import React from 'react';
import { Button, CircularProgress, styled } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

interface WrapperProps {
    gutterBottom?: boolean;
    fullWidth?: boolean;
}

const StyledWrapper = styled('div')<WrapperProps>(({ theme, gutterBottom, fullWidth }) => ({
    ...(fullWidth && { width: '100%' }),
    ...(gutterBottom && { marginBottom: theme.spacing(2) })
}));

export type LoadingButtonProps = ButtonProps & {
    loading?: boolean;
    gutterBottom?: boolean;
};

export const LoadingButton = (props: LoadingButtonProps) => {
    const { loading, gutterBottom, onClick, fullWidth, ...rest } = props;

    return (
        <StyledWrapper gutterBottom={gutterBottom} fullWidth={fullWidth}>
            <Button
                {...rest}
                className={props.className}
                onClick={loading ? undefined : onClick}
                loading={loading}
                loadingPosition="center"
                fullWidth={fullWidth}
                loadingIndicator={<CircularProgress size={24} sx={{ color: 'text.hint' }} />}
            >
                {props.children}
            </Button>
        </StyledWrapper>
    );
};
